import * as Yup from 'yup'

const SalesDealsSchema = Yup.object().shape({
  use_existing_user: Yup.boolean()
    .default(true)
    .required('Required'),
  
  edit_existing_user: Yup.boolean()
    .default(false)
    .required('Required'),

  user_id: Yup.number()
    .integer()
    .nullable(),

  email: Yup.string()
    .trim()
    .nullable(),

  password: Yup.string()
    .trim()
    .nullable(),

  name: Yup.string()
    .trim()
    .nullable(),

  phone: Yup.string()
    .trim()
    .nullable(),

  phone_code: Yup.string()
    .trim()
    .nullable(),

  complete_address: Yup.string()
    .trim()
    .nullable(),

  recipient_name: Yup.string()
    .trim()
    .nullable(),

  recipient_number: Yup.string()
    .trim()
    .nullable(),

  instruction: Yup.string()
    .trim()
    .nullable(),

  latitude: Yup.number()
    .min(-90, 'Latitude harus lebih besar atau sama dengan -90')
    .max(90, 'Latitude harus lebih kecil atau sama dengan 90')
    .nullable(),

  longitude: Yup.number()
    .min(-180, 'Longitude harus lebih besar atau sama dengan -180')
    .max(180, 'Longitude harus lebih kecil atau sama dengan 180')
    .nullable(),

  items: Yup.array()
    .of(
      Yup.object().shape({
        product_id: Yup.number()
          .integer()
          .required('Required'),
        //allow for custom selling price (different from the price data in product)
        selling_price: Yup.number()
          .positive()
          .required('Required'),
        //pre-defined options + notes in frontend. free text in backend
        authenticator: Yup.string()
          .trim()
          .nullable(true),
        //pre-defined options + notes in frontend. free text in backend
        authenticity_check_note: Yup.string()
          .trim()
          .nullable(true),
        //will be checked during Order List flow by ops team
        include_authenticity_check: Yup.boolean()
          .default(false),
        //other notes
        note: Yup.string()
          .trim()
          .nullable(true),
      })
    )
    .min(1, 'At least one product must be selected')
    .required('Items are required'),
  
  courier: Yup.object().shape({
    rate: Yup.object().shape({
      id: Yup.number()
        .integer()
        .required('Required'),
    }),
  }).nullable(),
  
  payment_method: Yup.object().shape({
    value: Yup.string()
      .trim()
      .required('Required'),
    installment: Yup.number()
      .integer()
      .nullable(),
  }).nullable(),

  voucher_code: Yup.string()
    .trim()
    .nullable(true),

  sales_method: Yup.string()
    .trim()
    .nullable(true),

  sales_name_in_invoice: Yup.string()
    .trim()
    .nullable(true),

  deal_by: Yup.string()
    .trim()
    .nullable(true),

  assist_by: Yup.string()
    .trim()
    .nullable(true),

  note: Yup.string()
    .trim()
    .nullable(true),

  pickup_at: Yup.date()
    .nullable(true),

  include_invoice: Yup.boolean()
    .default(true),

  include_polaroid: Yup.boolean()
    .default(false),

  include_love_letter: Yup.boolean()
    .default(false),

  down_payment: Yup.number()
    .nullable(true)
})

export default SalesDealsSchema
